import App from "./components/App.jsx";
import {initializeDialogueTheme} from "../../../../../shared/js";
import {RadioButton, CheckboxButton} from "@ignitesales/neuro-application";

// noinspection JSIgnoredPromiseFromCall
initializeDialogueTheme({
    ThemeComponent: App,
    webFont: {
        google: {
            families: [
                'Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&display=swap',
                'Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900'
            ]
        }
    },
    messages: {
        en: {
            'summary.title': 'Your Product Results'
        }
    },
    questionTypes: {
        Radio: RadioButton, //Overriding Radio Native so that Button is always used, same for checkbox
        Checkbox: CheckboxButton
    }
});
